module.exports = __webpack_public_path__ + "img/newcustomers.0e8ffaa8.svg";